import React, { Component } from 'react';
import Header from '../../components/main.header.component';
import { NavLink } from 'react-router-dom';
class Other extends Component {
  constructor(){
    super();
    this.state = {
      showOther: false,
    };
  }

  componentWillMount() {

  }
  render() {
    return(
      <div className="Other-container">
        <Header
          props={this.props}
        />
        <div className="other">
          <div className="header-other">
            o t h e r<br/>
          </div>
          <div className="other-weird">
            (it may get weird)
          </div>
        </div>
        <div className="other-space">
        </div>
        <NavLink to="/beer-recipes">
        <div className="yep">

        <div className="other">
          <div className="header-recipe" >
            r e c i p e s<br/>
          </div>
        </div>
        </div>
        </NavLink>
        <div className="other-space">
        </div>

        <NavLink to="/sounds">
        <div className="other-sounds">
        <img className="other-header-stretch" alt="sounds" src="https://media2.giphy.com/media/8RMOk2oM2RTDW/giphy.gif" />
          <div className="header-sounds" >
            s o u n d s<br/>
          </div>
        </div>
        <br />
        <br />
        <br />
        </NavLink>
      </div>
    )
  }
}

export default Other;




//          <img className="other-header-stretch" alt="sounds" src="https://media2.giphy.com/media/8RMOk2oM2RTDW/giphy.gif" />